import React, { useEffect, useState } from "react";
import "./loading.scss";


const Loading = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="loading_wrp">
      <img src={require("../../img/loading.gif")} alt="Loading" />
      <br />
      <span>{seconds}s Just a moment, getting things ready… </span>
    </div>
  );
};

export default Loading;
